export const isLoggedIn = (state: RootState) => !!state.auth.accessToken;
export const getUserPhoneNumber = (state: RootState) => state.auth.phone;
export const getAuthToken = (state: RootState) => state.auth.accessToken;
